import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';

const PERMISSION_MESSAGE = 'Habilitá la ubicación para compartir tu recorrido. Si rechazaste el permiso, abrí Ajustes > Aplicaciones > IFCI TEC > Permisos > Ubicación y permití el acceso mientras usás la app. En el navegador, habilitá Ubicación en los permisos del sitio. Después, reintentá.';

export function describeTrackingLocationError(error) {
    const code = String(error?.code || '');
    if (code === '1' || code === 'OS-PLUG-GLOC-0003' || code === 'GPS_PERMISSION_REQUIRED') {
        return PERMISSION_MESSAGE;
    }
    if (code === 'OS-PLUG-GLOC-0007' || code === 'OS-PLUG-GLOC-0009') {
        return 'La ubicación del dispositivo está desactivada. Encendé Ubicación/GPS en los ajustes del teléfono y reintentá.';
    }
    if (code === '3' || code === 'OS-PLUG-GLOC-0010') {
        return 'No se pudo obtener la ubicación a tiempo. Buscá un lugar con mejor señal GPS y reintentá.';
    }
    if (code === '2' || code === 'OS-PLUG-GLOC-0002') {
        return 'No se pudo obtener la ubicación. Revisá la señal GPS y reintentá.';
    }
    return error?.message || 'No se pudo obtener la ubicación. Revisá el permiso y que el GPS esté encendido, y reintentá.';
}

/** Solicitar permisos solo a partir de la acción explícita del usuario. */
export async function getTrackingPosition({ requestPermission = false } = {}) {
    const options = { enableHighAccuracy: true, timeout: 15000, maximumAge: 15000 };
    if (Capacitor.isNativePlatform()) {
        let permissions = await Geolocation.checkPermissions();
        const isGranted = () => permissions.location === 'granted' || permissions.coarseLocation === 'granted';
        if (!isGranted() && requestPermission) {
            permissions = await Geolocation.requestPermissions({ permissions: ['location'] });
        }
        if (!isGranted()) {
            const error = new Error(PERMISSION_MESSAGE);
            error.code = 'GPS_PERMISSION_REQUIRED';
            throw error;
        }
        return Geolocation.getCurrentPosition(options);
    }

    if (typeof navigator === 'undefined' || !navigator.geolocation) {
        throw new Error('Este navegador no permite obtener la ubicación. Usá la app o abrí el sitio con HTTPS y habilitá Ubicación.');
    }
    // En web, getCurrentPosition es quien muestra el permiso del navegador.
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, options);
    });
}
